export default "__VITE_ASSET__854593a6__"